/** O padrão do balcão brasileiro. */
export const DEFAULT_COPY_LABELS = {
    first: 'VIA DO CLIENTE',
    second: 'VIA DA LOJA',
};
/**
 * Tira o corte do fim, porque ele volta depois.
 *
 * Todo construtor termina o documento com `{ kind: 'cut' }` — é o fim do papel.
 * Empilhar dois documentos inteiros deixaria um corte no meio da primeira via,
 * antes do rótulo dela.
 */
const withoutTrailingCut = (blocks) => {
    let end = blocks.length;
    while (end > 0 && blocks[end - 1]?.kind === 'cut')
        end -= 1;
    return blocks.slice(0, end);
};
const copyBlocks = (blocks, label) => [
    ...blocks,
    { kind: 'feed', lines: 1 },
    { kind: 'text', text: label, align: 'center', bold: true },
];
/**
 * O mesmo documento duas vezes, com corte no meio e rótulo em cada via.
 *
 * O documento devolvido é do mesmo `kind` e do mesmo `title`: para quem imprime
 * e para quem roteia, continua sendo um recibo — só que com duas vias dentro.
 */
export const twoCopiesOf = (document, labels = DEFAULT_COPY_LABELS) => {
    const body = withoutTrailingCut(document.blocks);
    return {
        /*
         * O resto do documento vai junto — a letra da loja (`style`) inclusive.
         * Montado campo a campo, a 2ª via saía na letra normal mesmo com o modelo
         * da Elite em "Maior" (22/10).
         */
        ...document,
        blocks: [
            ...copyBlocks(body, labels.first),
            { kind: 'cut' },
            ...copyBlocks(body, labels.second),
            { kind: 'cut' },
        ],
    };
};
//# sourceMappingURL=copies.js.map